import React from "react";
import Imgs from "../../assets/logoown.jpg";
import { IoIosArrowDropdown } from "react-icons/io";
import { MdCancel } from "react-icons/md";
import style1 from "./workout.module.css"
const Absworkout = () => {
    
    
    return (
        <>
            <div className={style1.head1}>
                <h1 className={style1.name}>Trainer</h1>
                <img src={Imgs} alt="not_found" className={style1.logo}/>
            </div>
            <div className={style1.body1}>
                <div className={style1.ex1}>
                    <p className={style1.p1}>Hany Rambod</p>
                    <pre className={style1.p01}>Nicknamed “The Pro Creator,” Hany Rambod has been constructing <br />
                                              championship-winning physiques for over 20 years.His ground- <br />
                                              breaking FST-7 system has helped his clients win a total of <br />
                                              24 Olympia titles.Rambod’s roster of champions includes winners <br />
                                              in categories including Mr. Olympia, Ms. Figure Olympia, 202 Olympia, <br />  
                                              212 Olympia, Classic Physique, and Physique Olympia.</pre>
                    {/* <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Fun()}/> */}
                    <div className={style1.box1}>
                        <img src="https://www.hanyrambod.com/wp-content/uploads/2023/12/FST-7-Hany-2.png" alt="" />
                    </div>
                    <div className={style1.video1} id="abs">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}}/>
                        <video src={Imgs.video} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex2}>
                    <p className={style1.p2}> Neil Hill</p>
                    <pre className={style1.p02}>Neil “Yoda” Hill — Official Team BSN Trainer, a Nutrition Coach, and <br />
                                                and creator of Y3T. Neil Hill is a former IFBB professional Bodybuilder,<br /> 
                                                a gym owner ,trainer, nutritionist and fitness writer/columnist and <br />
                                                coach to some of the world’s top athletes including Team BSN Flex Lewis.<br />
                                                Neil is bodybuilding legend in the United Kingdom and his hand-crafted <br />
                                                Y3T (Yoda 3 Training) system which is now the go to system for thousands <br />
                                                of fitness enthusiasts and bodybuilders!</pre>
                    {/* <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Fun1()}/> */}
                    <div className={style1.box2}>
                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYnLLde_r3ctNV4uKmT81voIyr0zIQy3n0Kw&s" alt="" />
                    </div>
                    <div className={style1.video2} id="crunch">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}}/>
                        <video src={Imgs.video1} controls width={350} height={200}></video>
                    </div>
                </div>
                {/* <div className={style1.ex3}>
                    <p className={style1.p3}>Russian Twist</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Fun2()}/>
                    <div className={style1.box3}>
                        <img src="https://media.istockphoto.com/id/1224033680/photo/fitness-woman-doing-twists-exercise-morning-workout-at-home.jpg?s=612x612&w=0&k=20&c=3mKU0lWZXCnleOzpnpdj8jh1N6nLhyr7h7YfiNhWPIw=" alt="" />
                    </div>
                    <div className={style1.video3} id="twist">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}}/>
                        <video src={Imgs.video2} controls width={350} height={200}></video>
                    </div>
                </div> */}
                <div className={style1.ex4} id="plank">
                    <p className={style1.p1}>Charles Glass</p>
                    <pre className={style1.p04}>Charles Glass, nicknamed ‘The Godfather of Bodybuilding’, is a well- <br />
                                                known name in the fitness industry. He is a legendary trainer who has <br />
                                                worked with many top-level bodybuilders.Charles Glass believes in the <br />
                                                importance of proper form and technique in training which reduces   <br />
                                                the risk of injury but also helps to maximize muscle activation and <br />
                                                growth.He also emphasizes the importance of nutrition and recovery <br />
                                                in bodybuilding training.
</pre>
                    {/* <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Func()}/> */}
                    <div className={style1.box1}>
                        <img src="https://i.pinimg.com/736x/e6/ed/40/e6ed40c7bcd43254a8699e1f1f82cc63.jpg" alt="" />
                    </div>
                    <div className={style1.video1} id="p">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}}/>
                        <video src={Imgs.video18} controls width={350} height={200}></video>
                    </div>
                </div>
                <div className={style1.ex5} id="crunch1">
                    <p className={style1.p1}>Chris Cormier</p>
                    <pre className={style1.p05}>Chris “The Real Deal” Cormier is an IFBB professional bodybuilder<br />
                                                from Palm Springs, California. He ranks among the best professional  <br />
                                                bodybuilders of all time. He was heavily involved with his school <br />
                                                weight lifting club and competed against lifters from others schools. <br />
                                                As he developed his weight lifting knowledge and understanding of <br />
                                                nutrition, his physique improved massively.Now Chris has dedicated <br />
                                                himself to the sport for life. He loves helping other people reach their <br />
                                                their fitness goals while working on his own physique. </pre>
                    {/* <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Func1()}/> */}
                    <div className={style1.box1}>
                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCkeDY144qz9STEal7T_xb_SFwsHAGg_7X3Q&s" alt="" />
                    </div>
                    <div className={style1.video1} id="c">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}}/>
                        <video src={Imgs.video19} controls width={350} height={200}></video>
                    </div>
                </div>
                {/* <div className={style1.ex6} id="crunch2">
                    <p className={style1.p1}>Mountain Climbers</p>
                    <IoIosArrowDropdown style={{color: 'white',fontSize: '25px',position: 'absolute',left: '88%',top: '30%',cursor: 'pointer'}}  onClick={()=>Func2()}/>
                    <div className={style1.box1}>
                        <img src="https://www.verywellfit.com/thmb/QT4phienUCtErxCGntR7orxvbzU=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/MountainClimbers_annotated-cba5a34ab0bb4c54b0a6bbaf0ed6d101.jpg" alt="" />
                    </div>
                    <div className={style1.video1} id="c2">
                        <MdCancel style={{fontSize: '25px',cursor:'pointer',position: 'absolute',left: '90%',top: '1%'}} onClick={()=>Deletec2()}/>
                        <video src={Imgs.video20} controls width={350} height={200}></video>
                    </div>
                </div> */}
            </div>
        </>
    )
}
export default Absworkout;